import React, { useEffect } from 'react';
import { useGlobal } from 'reactn';
import NavMain from './com/NavMain';
import Routes from './Routes';
import useKeyboardInset from '@/lib/hooks/useKeyboardInset';
// global styles.
import 'normalize.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import 'equasion-lib/dist/index.css';
import './App.scss';

function App({ foundCurrentUser, refetch, ...props }) {
  const [userSession, setUserSession] = useGlobal('userSession');
  const { roles = [] } = foundCurrentUser || {};
  // Lifts every bottom-sheet modal above the on-screen keyboard (see App.scss).
  useKeyboardInset();

  // Logs in and stores user when user data comes through
  useEffect(() => {
    if (!userSession && !!foundCurrentUser)
      setUserSession({
        roles,
        loggedIn: true,
        userInfo: foundCurrentUser
      });
  }, [foundCurrentUser]);

  return (
    <>
      {/* {!!foundCurrentUser && <NavMain {...props} />} */}
      <Routes foundCurrentUser={foundCurrentUser} {...props} />
    </>
  );
}

export default App;
